// extracted by mini-css-extract-plugin
module.exports = {"root":"IconGroup_root__3CpFy"};